import type { PackageSelectionSnapshotDTO, PackageSelectionSnapshotOption } from "@/api/business/types/product"

export interface PackageChildPrintItem {
  itemName: string
  itemQuantity: string
  count: number | null
}

export function buildPackageChildPrintItems(
  snapshot: PackageSelectionSnapshotDTO | null | undefined,
): PackageChildPrintItem[] {
  const groups = snapshot?.groups ?? []
  if (!groups.length) {
    return []
  }

  return groups.flatMap(group => (group.options ?? []).flatMap((option) => {
    const itemName = option.childItemName?.trim()
    if (!itemName) {
      return []
    }
    const optionCount = toPackageOptionPrintQuantity(option)
    if (optionCount === null) {
      return []
    }
    const count = optionCount
    return [{
      itemName,
      itemQuantity: String(count),
      count,
    }]
  }))
}

export function packageSelectionKey(snapshot: PackageSelectionSnapshotDTO | null | undefined) {
  if (!snapshot) {
    return ""
  }
  if (snapshot.selectionHash) {
    return snapshot.selectionHash
  }
  try {
    return JSON.stringify(snapshot.groups ?? [])
  } catch (_e) {
    return ""
  }
}

function toOptionalPrintQuantity(value: number | string | null | undefined) {
  if (value === null || value === undefined || value === "") {
    return null
  }
  const quantity = Number(value)
  return Number.isFinite(quantity) ? quantity : null
}

function toOptionalPositivePrintQuantity(value: number | string | null | undefined) {
  const quantity = toOptionalPrintQuantity(value)
  return quantity !== null && quantity > 0 ? quantity : null
}

function toPackageOptionPrintQuantity(option: PackageSelectionSnapshotOption) {
  return toOptionalPositivePrintQuantity(option.selectedQuantity)
}
